<template>
  <div>
    <el-form class="word-form" ref="form" label-width="80px">
      <el-form-item label="等级">
        <course-select v-model="form.course_id" nostore class="ml8" placeholder="课程"></course-select>
        <el-select filterable v-model="form.level" placeholder="等级" class="ml8">
          <el-option
            v-for="item in $store.getters.getLevels(form.course_id)"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="form.num" placeholder="序号" style="width:80px;"></el-input>
      </el-form-item>
      <el-form-item label="词汇">
        <el-input v-model="form.text"></el-input>
      </el-form-item>
      <el-form-item label="拼音">
        <PinyinInput v-model="form.pinyin" :text="form.text" :uppercase="false"></PinyinInput>
      </el-form-item>
      <el-form-item label="驰声语音">
        <el-input v-model="form.text_chivox"></el-input>
      </el-form-item>
      <el-form-item label="词性">
        <GrammarSelect v-model="form.gids" :types="form.grammars" placeholder="词性" :clearable="true"></GrammarSelect>
      </el-form-item>
      <el-form-item label="图片">
        <FileInput v-model="form.image" accept="image/*"></FileInput>
      </el-form-item>
      <el-form-item label="音频">
        <FileInput v-model="form.audio" accept="audio/*"></FileInput>
      </el-form-item>
      <el-form-item label="内部备注">
        <el-input v-model="form.memo"></el-input>
      </el-form-item>
      <el-form-item class="subtitle-list" label="例句">
        <Mark ref="sntmark" :hints="form.text" selector=".text" :strict="true">
          <Sentences ref="sentences" :sentences="form.sentences" :gid="form.id" :upload-image="true" style="margin-top:-12px;"></Sentences>  
        </Mark>
      </el-form-item>
      <Help v-model="form.help"></Help>
      <el-form-item label="有效">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import GrammarSelect from './GrammarSelect'
import Help from './../HelpInlineForm.vue'
import Mark from './../Mark.vue'
import Sentences from './../grammar/Sentences'
import CourseSelect from "@/components/CourseSelect.vue";

export default {
  name: 'WordForm',
  components: {
    CourseSelect,
    PinyinInput: require('@/components/PinyinInput').default,
    FileInput: require('@/components/FileInput').default,
    Help,
    GrammarSelect,
    Mark,
    Sentences
  },
  data () {
    return {
      form: {
        id: null,
        course_id: null,
        level: null,
        num: null,
        gids: [],
        grammars: [],
        status: true,
        text: '',
        memo: '',
        pinyin: '',
        text_chivox: '',
        help: {},
        type: null,
        showType: null,
        sentences: []
      }
    }
  },
  watch: {
    'form.sentences' () {
      this.$refs.sntmark.renderMark()
    }
  },
  methods: {
    reset (model) {
      let obj = Object.assign({
        id: null,
        course_id: null,
        level: null,
        num: null,
        gids: [],
        grammars: [],
        text: '',
        memo: '',
        pinyin: '',
        text_chivox: '',
        image: '',
        audio: '',
        status: 1,
        help: {},
        sentences: []
      }, model)
      obj.status = !!obj.status
      if (obj.grammars) {
        obj.gids = obj.grammars.map(n => n.id)
      } else {
        obj.gids = obj.gids.map(n => {
          return typeof n === 'object' ? n.tid : n
        })
      }
      this.form = obj
    },
    getFormData () {
      return {
        id: this.form.id,
        course_id: this.form.course_id,
        level: this.form.level,
        num: this.form.num,
        gids: this.form.gids,
        title: this.form.title,
        text: this.form.text,
        pinyin: this.form.pinyin,
        image: this.form.image,
        audio: this.form.audio,
        memo: this.form.memo,
        text_chivox: this.form.text_chivox,
        status: this.form.status ? 1 : 0,
        help: this.form.help,
        sentences: this.form.sentences.filter(s => s.id || s.text).map(s => {
          return {
            id: s.id,
            wid: s.gid,
            sid: s.sid,
            weight: s.weight,
            sentence: {
              id: s.sid,
              course_id: this.form.course_id,
              text: s.text,
              pinyin: s.pinyin,
              audio: s.audio,
              image: s.image,
              text_chivox: s.text_chivox,
              data_json: s.data_json
            }
          }
        }).concat(this.$refs.sentences.deletedSentences.map(s => {
          return {
            id: s.id,
            sid: s.sid,
            gid: s.gid,
            deleted: true
          }
        }))
      }
    },
    submit () {
      var params = this.getFormData()
      if (this.form.id) {
        delete params.id
        return this.$http.put(this.$urls.word_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.word_create, params).then(data => {
          this.form.id = data.id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .pinyin-preview{
    margin-left: 80px;
    margin-top: -10px;
    border-top: 1px solid #ddd;
    padding-top: 15px;
  }
</style>
